import React, { useState } from "react";
import ExpensesMobile from "../depenses/ExpensesMobile";
import ExpenseCategoriesMobile from "../depenses/ExpenseCategoriesMobile";
import { useAuth } from "../../context/AuthContext";

const PERMISSIONS = {
  entries: {
    VIEW: "logistics.expenses.entries.view",
    CREATE: "logistics.expenses.entries.create",
    EDIT: "logistics.expenses.entries.edit",
    DELETE: "logistics.expenses.entries.delete",
    EXPORT: "logistics.expenses.entries.export",
    CREATE_PAYMENT: "logistics.expenses.entries.create_payment",
  },
  categories: {
    VIEW: "logistics.expenses.categories.view",
    EDIT: "logistics.expenses.categories.edit",
    DELETE: "logistics.expenses.categories.delete",
  },
};

export default function LogisticsExpensesMobile() {
  const { user, hasPermission } = useAuth();
  const [view, setView] = useState("entries");
  const canViewEntries = user?.is_superadmin || hasPermission(PERMISSIONS.entries.VIEW);
  const canViewCategories = user?.is_superadmin || hasPermission(PERMISSIONS.categories.VIEW);
  const effectiveView = view === "entries" && !canViewEntries && canViewCategories
    ? "categories"
    : view === "categories" && !canViewCategories && canViewEntries
      ? "entries"
      : view;
  const switchView = (nextView) => {
    if (nextView === "entries" && canViewEntries) setView(nextView);
    if (nextView === "categories" && canViewCategories) setView(nextView);
  };

  return effectiveView === "entries" ? (
    <ExpensesMobile
      moduleScope="logistics"
      permissions={PERMISSIONS.entries}
      title="Charges Admin"
      onNavigateSibling={switchView}
    />
  ) : (
    <ExpenseCategoriesMobile
      moduleScope="logistics"
      permissions={PERMISSIONS.categories}
      title="Catégories de charges"
      onNavigateSibling={switchView}
    />
  );
}
